import { render, staticRenderFns } from "./SadFaceIcon.vue?vue&type=template&id=1e6557af&"
import script from "./SadFaceIcon.vue?vue&type=script&lang=js&"
export * from "./SadFaceIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports